module.exports = __webpack_public_path__ + "img/diners_club.3c2a7162.png";